import { axios } from '@Root/API'

export const create = (student_course_session_id, payload) => {
	return axios.post('attache/funding-and-monitoring/student-course-session', { ...payload, student_course_session_id })
}
